import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { PaginationItem, Stack, TablePaginationProps } from "@mui/material";
import MuiPagination from "@mui/material/Pagination";
import {
  GridPagination,
  gridPageCountSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";

import Text from "./Text";

const BackArrowWithPageText = () => {
  return (
    <Stack direction="row" alignItems="center">
      <ArrowBackIosIcon fontSize="small" />
      <Text variant="body_small">Page</Text>
    </Stack>
  );
};

function Pagination({
  page,
  onPageChange,
  className,
  count,
}: Pick<
  TablePaginationProps,
  "page" | "onPageChange" | "className" | "count"
>) {
  const apiRef = useGridApiContext();
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <MuiPagination
      sx={{
        ".MuiPaginationItem-root.MuiPaginationItem-text.Mui-selected": {
          backgroundColor: "transparent",
          fontWeight: "800",
          color: "black",
        },
        "& .MuiPaginationItem-page": {
          backgroundColor: "transparent",
          color: "grey",
        },
      }}
      renderItem={item => (
        <PaginationItem
          slots={{
            previous: BackArrowWithPageText,
            next: ArrowForwardIosIcon,
          }}
          {...item}
        />
      )}
      className={className}
      count={count ?? pageCount}
      page={page + 1}
      onChange={(event, newPage) => {
        onPageChange(
          event as unknown as React.MouseEvent<HTMLButtonElement>,
          newPage - 1,
        );
      }}
    />
  );
}

function CustomPagination(props: object) {
  return (
    <GridPagination
      labelDisplayedRows={() => undefined}
      ActionsComponent={Pagination}
      rowsPerPageOptions={[]}
      {...props}
    />
  );
}

export default CustomPagination;
